











































































































import { Component, Vue } from 'vue-property-decorator';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { ContactCategory } from '@/data/models/contatto.model';
import { User, UserType } from '@/data/models/user.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import { CampaignContactStatus } from '@/data/models/campaign.model';

@Component
export default class CampagnaContattiTableFilter extends Vue {

	advancedSearch: Search;

	searchParam: any = new class {
		mobile: string = '';
		name: string = '';
		surname: string = '';
		status?: CampaignContactStatus = CampaignContactStatus.QUEUE;
		category?: ContactCategory;
		landline?: string = '';
		operatore?: User;
	};

	userClass: ClassType<User> = User;
	operatoreSearch: Search = new Search('user');

	state!: State;

	categories = Object.keys(ContactCategory).map(
		// @ts-ignore
		(k: string) => ContactCategory[k]
	);

	statuses = Object.keys(CampaignContactStatus).map(
		// @ts-ignore
		(k: string) => CampaignContactStatus[k]
	);

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('campaigncontact join contact on campaigncontact.contactid = contact.id');
	}

	created() {
		this.initSearch();
		this.search();
	}

	initSearch() {
		this.operatoreSearch.reset();
		this.operatoreSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.operatoreSearch.addSimpleFilter('utype', UserType.CALL_CENTER);
	}

	search() {
		this.advancedSearch.reset();

		if (this.searchParam.mobile) this.advancedSearch.addLikeFilter('contact.mobile', this.searchParam.mobile);
		if (this.searchParam.name) this.advancedSearch.addLikeFilter('contact.name', this.searchParam.name);
		if (this.searchParam.surname) this.advancedSearch.addLikeFilter('contact.surname', this.searchParam.surname);
		if (this.searchParam.status) this.advancedSearch.addSimpleFilter('status', this.searchParam.status);
		if (this.searchParam.category) this.advancedSearch.addSimpleFilter('category', this.searchParam.category);
		if (this.searchParam.landline) this.advancedSearch.addLikeFilter('contact.landline', this.searchParam.landline);
		if (this.searchParam.operatore && this.searchParam.operatore.id) this.advancedSearch.addSimpleFilter('operatorid', this.searchParam.operatore.id);

		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.name = '';
		this.searchParam.surname = '';
		this.searchParam.mobile = '';
		this.searchParam.category = undefined;
		this.searchParam.status = undefined;
		this.searchParam.landline = '';
		this.searchParam.operatore = {};
		this.search();
	}

}
